"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrReasonsOfConfidence = void 0;
const react_1 = __importDefault(require("react"));
const fdr_footer_styles_1 = require("./fdr-footer.styles");
function FdrReasonsOfConfidence(_a) {
    var { title, text, className } = _a, divProps = __rest(_a, ["title", "text", "className"]);
    return (react_1.default.createElement(fdr_footer_styles_1.FdrROCWrapper, Object.assign({ "data-id": "fdr-reasons-of-confidence", className: className }, divProps),
        title ? (react_1.default.createElement(fdr_footer_styles_1.FdrFooterHeading, { "data-id": "fdr-roc-title" }, title)) : null,
        text ? (react_1.default.createElement(fdr_footer_styles_1.FdrROCContent, { "data-id": "fdr-roc-content", dangerouslySetInnerHTML: { __html: text } })) : null));
}
exports.FdrReasonsOfConfidence = FdrReasonsOfConfidence;
//# sourceMappingURL=fdr-reasons-of-confidence.js.map